import React from 'react';
import { DModal } from '../../../../../dum';
import { OrderSaleIcon } from '../../../../icons';
import { OrderSaleStatusChangeForm } from './order-sale-status-change-form';

interface ISUpdateOrderSaleStatusDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderSaleId: number | null;
    currentStatusId?: number | null;
}

export function SUpdateOrderSaleStatusDialog({
    open,
    setOpen,
    orderSaleId,
    currentStatusId,
}: ISUpdateOrderSaleStatusDialogProps) {
    return (
        <DModal
            icon={<OrderSaleIcon />}
            title={'Cambiar status de la venta'}
            open={open}
            setOpen={setOpen}
        >
            {orderSaleId ? (
                <OrderSaleStatusChangeForm
                    orderSaleId={orderSaleId}
                    currentStatusId={currentStatusId}
                    onSuccess={() => setOpen(false)}
                />
            ) : null}
        </DModal>
    );
}
